import { render, staticRenderFns } from "./addNew.vue?vue&type=template&id=7955dfbb&scoped=true&"
import script from "./addNew.vue?vue&type=script&lang=js&"
export * from "./addNew.vue?vue&type=script&lang=js&"
import style0 from "./addNew.vue?vue&type=style&index=0&id=7955dfbb&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7955dfbb",
  null
  
)

export default component.exports